module.exports = __webpack_public_path__ + "static/img/laxin.a941cc71.png";